import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRGrandTotal({ totals }) {


  //console.log("Grand Total", totals);
const parseAmount = (value) => {
  if (value == null) return 0;

  let str = String(value).replace(/,/g, "").trim();

  // Handle trailing minus
  if (str.endsWith("-")) {
    str = "-" + str.slice(0, -1);
  }

  return Number(str) || 0;
};


const total = (parseAmount(totals[0].PRIMECOST_STORES) || 0) + (parseAmount(totals[0].ONCOST_STORES) || 0);
//const totalStore = (parseAmount(totals.DirectStore) || 0) + (parseAmount(totals.OnCostStore) || 0);

  return (
    <Paper
      elevation={4}
      sx={{
        mt: 3,
        overflow: "hidden",
        border: "2px solid",
        borderColor: "success.main",
      }}
    >
     

      <Grid
        container
        spacing={0}
        justifyContent="center"
        alignItems="flex-start"
        sx={{ mb: 20, px: 2 }}
      >
       

    


        <Grid size={{ xs: 12, md: 4 }} >

          <TableContainer
            component={Paper}
            variant="outlined"
           
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 16,
                    }}
                  >
                    Description
                  </TableCell>
                   <TableCell
                    
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 16,
                    }}
                  >
                    Amount
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>


 <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                     Direct Store(as per WGR)
                    </Typography>
                    
                  </TableCell>


                  <TableCell align="right">
                    <CurrencyCell value={totals[0].PRIMECOST_STORES} />
                  </TableCell>

                </TableRow> 


                 <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                     On Cost Store ( as per WGR on Cost)
                    </Typography>
                    
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={totals[0].ONCOST_STORES} />
                  </TableCell>
                </TableRow>



                 <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                     Total
                    </Typography>
                    
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={total} />
                  </TableCell>
                </TableRow>


              </TableBody>
            </Table>
          </TableContainer>

        </Grid>



      </Grid>
    </Paper>
  );
}